import { atom } from "recoil"

export const positionFsBadgeHistoryAtom = atom<"bottom" | "top" | "middle">({
  key: "positionFsBadgeHistory",
  default: "middle"
})

export const positionFsVideosAtom = atom<"bottom" | "top" | "middle">({
  key: "positionFsVideosAtom",
  default: "middle"
})
